<odx-modal-header>
  <odx-area-header i18n="@@invitation.modal.header">Einladung zur Kollaboration abschließen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (invitationResult$ | async; as response) {
    <div>
      @if (response.ok) {
        <p i18n="@@invitation.message.success">
          Sie haben nun Zugriff auf das Projekt <b>{{ projectName }}</b
          >. Im Anschluss wird das Projekt aus der Cloud importiert.
        </p>
      }

      @if (response.status === 403 && response.body.message === "Business scopes do not match") {
        <p i18n="@@invitation.message.forbidden">
          Es ist ein Fehler aufgetreten. Die Einladung wurde nicht abgeschlossen, da der User Business Scope und der Projekt
          Business Scope nicht übereinstimmen.
        </p>
      } @else if (response.status !== 200) {
        <p i18n="@@invitation.message.failure">Es ist ein Fehler aufgetreten. Die Einladung wurde nicht abgeschlossen</p>
      }
    </div>
  } @else {
    <p i18n="@@invitation.message.processValidation">Der Status ihrer Einladung wird überprüft.</p>
    <p [odxLoadingSpinner]="true" [odxLoadingSpinnerMinHeight]="500"></p>
  }
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" (click)="onConfirm()" i18n="@@modal.generalConfirmation.button.confirm">OK</button>
</odx-modal-footer>
